import {
  IconDashboard,
  IconUser,
  IconUsers,
  IconFileText,
  IconSettings,
  IconWallet,
  IconMail,
  IconBuilding,
  IconCreditCard
} from '@tabler/icons-react';

const reseller = {
  id: 'reseller',
  title: 'Reseller',
  type: 'group' as const,
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item' as const,
      url: '/dashboard',
      icon: IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'management',
      title: 'Management',
      type: 'collapse' as const,
      icon: IconBuilding,
      children: [
        {
          id: 'customers',
          title: 'Customers',
          type: 'item' as const,
          url: '/customers',
          icon: IconUsers,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'subscriptions',
      title: 'Subscriptions',
      type: 'item' as const,
      url: '/subscriptions',
      icon: IconFileText,
      breadcrumbs: false
    },
    {
      id: 'orders',
      title: 'Orders',
      type: 'item' as const,
      url: '/orders',
      icon: IconWallet,
      breadcrumbs: false
    },
    {
      id: 'campaigns',
      title: 'Campaigns',
      type: 'item' as const,
      url: '/campaigns',
      icon: IconMail,
      breadcrumbs: false
    },
    {
      id: 'credits',
      title: 'Credits',
      type: 'item' as const,
      url: '/credits',
      icon: IconCreditCard,
      breadcrumbs: false
    },
    {
      id: 'profile',
      title: 'Profile',
      type: 'item' as const,
      url: '/profile',
      icon: IconUser,
      breadcrumbs: false
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'item' as const,
      url: '/settings',
      icon: IconSettings,
      breadcrumbs: false
    }
  ]
};

export default reseller;
